import { AdsSelene } from "@amzn/ads-selene-client";
import { getCredentialsFromCacheOrCognito } from "@amzn/midway-cognito-type-script-provider";

import { authStore } from "../../store/auth";
import { APPENV } from "../../utils/app.environment";

export async function getSeleneApiClient(): Promise<AdsSelene> {
    try {
        const {
            settings: { cognitoPoolId, region, seleneApiEndpoint },
        } = authStore.getState();

        if (!seleneApiEndpoint) {
            throw new Error("Selene endpoint not yet defined");
        }

        const { accessKeyId, secretAccessKey, sessionToken } =
            await getCredentialsFromCacheOrCognito({
                region,
                identityPoolId: cognitoPoolId,
                clientId: window.location.host,
                redirectUri: window.location.href,
            });

        const client = new AdsSelene({
            endpoint: `${
                APPENV.mock_server ? "http" : "https"
            }://${seleneApiEndpoint}`,
            region,
            credentials: { accessKeyId, secretAccessKey, sessionToken },
        });

        return client;
    } catch (e: any) {
        throw new Error(e.message);
    }
}
